import axios from "@/lib/axios";
import { serializeSortQueryParam } from "@/lib/utils";
import { SpringPage, SpringPageableRequest } from "@/types/apis";
import { Resource, ResourceType } from "@/types/resources";

export type ListEditionResourcesRequestParams = SpringPageableRequest & {
  editionId: string;
  resourceLibraryId: string;
  q?: string;
  types?: ResourceType[];
};

export type ListEditionResourcesResponse = SpringPage<Resource>;

export const listEditionResources = (
  params: ListEditionResourcesRequestParams,
) =>
  axios
    .get<ListEditionResourcesResponse>(
      `/v1/editions/${params.editionId}/resource-libraries/${params.resourceLibraryId}/resources`,
      {
        params: {
          q: params.q,
          types: params.types,
          page: params.page,
          size: params.size,
          sort: serializeSortQueryParam(params.sort),
        },
      },
    )
    .then((res) => res.data);
